import {sanitizeFileNamePart} from 'app/helpers/export-file-name';
import {VAT_OBJEKT_COPY} from '@vat/vat-copy';

/**
 * Dateinamen der Exporte (A2): Muster der Aufgabenstellung mit den Sanitizing-Regeln von buildExportFileName.
 *
 * @author Anthony Nahas
 * @since 11.09.26
 */
export type VatExportFileExtension = 'pdf' | 'xlsx';

const token = (value: unknown, fallback: string): string => sanitizeFileNamePart(value, fallback).replace(/\s+/g, '-');

export const buildVatExportFileName = (p: { landlordName: string; year: number; periodKey: string; version: number; extension: VatExportFileExtension; kind?: 'VORANMELDUNG' | 'HERLEITUNG' }): string => {
    const prefix = p.kind === 'HERLEITUNG' ? 'Umsatzsteuer-Herleitung' : 'Umsatzsteuer-Voranmeldung';
    return `${prefix}_${token(p.landlordName, 'Eigentuemer')}_${p.year}-${p.periodKey}_v${p.version}.${p.extension}`;
};

export const buildKz48FileName = (landlordName: string, year: number): string => `Kz-48-Nachweis_${token(landlordName, 'Eigentuemer')}_${year}.pdf`;

/**
 * Objekt-Abrechnung (Spec 2026-09-13 Sektion 2.3): `Umsatzsteuerabrechnung_{Eigentümer}_{H-Label}_{Jahr}[-{Zeitraum}].{pdf|xlsx}`.
 * Vom Immobilien-Label („H24 · Musterstraße 1, …“) wird nur der H-Teil vor „ · “ verwendet; `periodKey` null = Kalenderjahr.
 */
export const buildObjektFileName = (landlordName: string, propertyLabel: string, year: number, periodKey: string | null, extension: VatExportFileExtension): string => {
    const hLabel = String(propertyLabel ?? '').split(' · ')[0];
    const zeitraum = periodKey ? `${year}-${periodKey}` : String(year);
    return `${VAT_OBJEKT_COPY.fileNamePrefix}_${token(landlordName, VAT_OBJEKT_COPY.fileNameFallbacks.landlord)}_${token(hLabel, VAT_OBJEKT_COPY.fileNameFallbacks.property)}_${zeitraum}.${extension}`;
};
